const LOADER_SIZES = Object.freeze({
  xs: "h-4 w-4",
  sm: "h-5 w-5",
  md: "h-7 w-7",
});

const REDUCED_MOTION_OPACITY = [1, 0.82, 0.68, 0.54, 0.42, 0.32, 0.24, 0.18];
const LOADER_MOTION_STYLES = `
  @keyframes yb-loader-dot-chase {
    0%, 100% { opacity: 0.18; transform: scale(0.72); }
    12.5% { opacity: 1; transform: scale(1); }
    37.5% { opacity: 0.38; transform: scale(0.84); }
  }
  html.safari-desktop .yb-loader__dot,
  .yb-loader__dot {
    animation: yb-loader-dot-chase 1s linear infinite !important;
    animation-delay: var(--yb-loader-dot-delay) !important;
    transform-origin: center;
    will-change: opacity, transform;
  }
  @media (prefers-reduced-motion: reduce) {
    html.safari-desktop .yb-loader__dot,
    .yb-loader__dot {
      animation: none !important;
      opacity: var(--yb-loader-dot-opacity);
      transform: scale(0.88);
      will-change: auto !important;
    }
  }
`;

export default function YourBarrioLoader({
  size = "sm",
  label = null,
  className = "",
  ...props
}) {
  const sizeClass = LOADER_SIZES[size] || LOADER_SIZES.sm;
  const accessible = Boolean(label);

  return (
    <>
      <style>{LOADER_MOTION_STYLES}</style>
      <span
        className={`yb-loader relative inline-block shrink-0 ${sizeClass} ${className}`.trim()}
        role={accessible ? "status" : undefined}
        aria-label={accessible ? label : undefined}
        aria-live={accessible ? "polite" : undefined}
        aria-busy={accessible ? "true" : undefined}
        aria-hidden={accessible ? undefined : "true"}
        data-yb-loader="true"
        data-size={size}
        {...props}
      >
        {REDUCED_MOTION_OPACITY.map((opacity, index) => (
          <span
            key={index}
            className="absolute inset-0"
            style={{ transform: `rotate(${index * 45}deg)` }}
          >
            <span
              className="yb-loader__dot absolute left-[39%] top-0 block h-[22%] w-[22%] rounded-full bg-current"
              style={{
                "--yb-loader-dot-delay": `${(index - REDUCED_MOTION_OPACITY.length) * 0.125}s`,
                "--yb-loader-dot-opacity": opacity,
              }}
            />
          </span>
        ))}
      </span>
    </>
  );
}
